import React from 'react';
import Projects from '../Home/Projects/Projects';

const Portfolio = () => {
    return (
        <div>
            <Projects></Projects>
        </div>
    );
};

export default Portfolio;